import { render } from "./DataList.vue?vue&type=template&id=4b405a3c&scoped=true"
import script from "./DataList.vue?vue&type=script&lang=js"
export * from "./DataList.vue?vue&type=script&lang=js"

import "./DataList.vue?vue&type=style&index=0&id=4b405a3c&scoped=true&lang=css"

import exportComponent from "/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b405a3c"]])

export default __exports__